import {ContactMessageState} from '@cp/model';
import {updateDoc} from 'firebase/firestore';
import getContactMessageDocRef from './getContactMessageDocRef';

export default async function updateContactMessageDoc(
  messageId: string,
  data: {state: ContactMessageState},
): Promise<void> {
  await updateDoc(getContactMessageDocRef(messageId), data);
}
